import { create } from "zustand";

interface Module {
    id: string;
    name: string;
}

interface Permission {
    id: string;
    user_id: string;
    module: Module;
    can_get_list: boolean;
    can_get_one: boolean;
    can_create: boolean;
    can_update: boolean;
    can_delete: boolean;
}

interface GlobalPermissionState {
    permissionList: Permission[];
    setPermissionList: (permissionList: Permission[]) => void;
}

const useGlobalPermission = create<GlobalPermissionState>((set) => ({
    permissionList: [],
    setPermissionList: (permissionList) => set(() => ({ permissionList: permissionList })),
}));

export default useGlobalPermission;
